export default {
  workLimitMustJoinAssign: '/achvClient/workLimitMustJoinAssign',
  assignMod: '/achvClient/assignMod'
}
